import PropTypes from 'prop-types';
import React from 'react';

import { LocationDetail } from '@/design-system/molecules/LocationDetail';

import { useMapContext } from '../../contexts/MapContext';
import styles from './InfoWindow.module.scss';

const InfoWindow = ({ content, analytics }) => {
    const mapContext = useMapContext();

    return (
        <div className={styles[`info-window`]}>
            <div className={styles[`info-window__content`]}>
                <LocationDetail
                    {...content}
                    variant={LocationDetail.VARIANT.CARD}
                    analytics={analytics}
                    onCloseClick={() => mapContext.setCurrentKey(null)}
                />
            </div>
        </div>
    );
};

InfoWindow.propTypes = {
    content: PropTypes.object,
};

export default InfoWindow;
